import { render, staticRenderFns } from "./BFormSummary.vue?vue&type=template&id=584db53c&scoped=true&"
import script from "./BFormSummary.vue?vue&type=script&lang=js&"
export * from "./BFormSummary.vue?vue&type=script&lang=js&"
import style0 from "./BFormSummary.vue?vue&type=style&index=0&id=584db53c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584db53c",
  null
  
)

export default component.exports